import { createVanIconComponent } from "./van"

const DiamondOutlined = createVanIconComponent("diamond-o")
export default DiamondOutlined
